import api from './api';

const dashboardService = {
  getStats: async () => {
    const response = await api.get('/dashboard/stats');
    return response.data;
  },

  search: async (query, limit) => {
    const response = await api.get('/dashboard/search', {
      params: limit ? { q: query, limit } : { q: query }
    });
    return response.data;
  },

  getLayout: async () => {
    const response = await api.get('/dashboard-layout');
    return response.data;
  },

  saveLayout: async (tiles, layout) => {
    const response = await api.put('/dashboard-layout', { tiles, layout });
    return response.data;
  },
};

export default dashboardService;
